<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 Produtividade — Resumo: Ações
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | No resumo do fiscal, quando o período
        strong  não
        |  está encerrado, você pode lançar pontuações extras e gerenciar
        strong  afastamentos
        | .

      .toast.toast-primary
        | As ações de pontuação aparecem apenas se
        strong  Encerrado = Não
        | . Afastamentos exige
        strong  Produtividade → Afastamentos → Criar
        |  (e o fiscal precisa ter cargo).

      h5.h5 1. Localizar as ações
      ol
        li Abra o resumo de um fiscal em um período
          strong  não encerrado
          | .
        li No rodapé da tela, use os botões
          strong  Incluir Serviços Extras
          | ,
          strong  Incluir Pontos Avulso
          | ,
          strong  Incluir Falta
          |  e
          strong  Afastamentos
          | .
      figure.manual-figure
        img(:src="imgAcoes" alt="Botões de ação no resumo do fiscal")

      h5.h5 2. Incluir Serviços Extras
      ol
        li Clique em
          strong  Incluir Serviços Extras
          | .
        li Informe
          strong  Horas trabalhadas
          | ,
          strong  Pontos por Hora
          |  e
          strong  Descrição
          | .
        li Confira o total de pontos calculado e clique em
          strong  Salvar
          | .
      figure.manual-figure
        img(:src="imgServicoExtra" alt="Modal Incluir Serviços Extras")

      h5.h5 3. Incluir Pontos Avulso
      ol
        li Clique em
          strong  Incluir Pontos Avulso
          | .
        li Informe
          strong  Pontos
          |  e
          strong  Descrição
          | .
        li Clique em
          strong  Salvar
          | .
      figure.manual-figure
        img(:src="imgAvulso" alt="Modal Incluir Pontos Avulso")

      h5.h5 4. Incluir Falta
      ol
        li Clique em
          strong  Incluir Falta
          | .
        li Informe
          strong  Horas em Falta
          | ,
          strong  Pontos por Hora
          |  e
          strong  Descrição
          | .
        li Clique em
          strong  Salvar
          | .
      figure.manual-figure
        img(:src="imgFalta" alt="Modal Incluir Falta")

      h5.h5 5. Afastamentos
      ol
        li Clique em
          strong  Afastamentos
          | .
        li Na tela, veja a média mensal e a lista de períodos (se houver).
        li Clique em
          strong  Novo Afastamento
          |  para informar início, fim e observação.
        li Salve o período; use excluir se precisar remover um afastamento.
      figure.manual-figure
        img(:src="imgAfastamentos" alt="Tela de Afastamentos do fiscal")

      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgAcoes: require("@/assets/manuais/28-produtividade-resumo-acoes.png"),
      imgServicoExtra: require("@/assets/manuais/28a-produtividade-servico-extra.png"),
      imgAvulso: require("@/assets/manuais/28b-produtividade-pontos-avulso.png"),
      imgFalta: require("@/assets/manuais/28c-produtividade-falta.png"),
      imgAfastamentos: require("@/assets/manuais/28d-produtividade-afastamentos.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
